import React from 'react';
import PropTypes from 'prop-types';

function IconAddedCart({ color = '#EF476F', size = 16, className }) {
  return (
    <svg id={'icon-added-cart'} width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.99976 2H4.52614L6.79988 12.4424C6.87862 12.8285 7.09029 13.1749 7.39803 13.421C7.70577 13.6672 8.09011 13.7977 8.48413 13.7898H14.9685C15.3625 13.7977 15.7469 13.6672 16.0546 13.421C16.3624 13.1749 16.574 12.8285 16.6528 12.4424L18.0002 5.36851H5.87354M8.31406 18C8.77916 18 9.15619 17.623 9.15619 17.1579C9.15619 16.6928 8.77916 16.3157 8.31406 16.3157C7.84897 16.3157 7.47194 16.6928 7.47194 17.1579C7.47194 17.623 7.84897 18 8.31406 18ZM15.0494 18C15.5145 18 15.8916 17.623 15.8916 17.1579C15.8916 16.6928 15.5145 16.3157 15.0494 16.3157C14.5843 16.3157 14.2073 16.6928 14.2073 17.1579C14.2073 17.623 14.5843 18 15.0494 18Z" stroke={color} fill={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconAddedCart.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconAddedCart;
